
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in
    const userEmail = localStorage.getItem('userEmail');
    const selectedCompany = localStorage.getItem('selectedCompany');
    
    if (userEmail && selectedCompany) {
      navigate('/dashboard');
    } else if (userEmail) {
      navigate('/company-selection');
    } else {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-purple-400 mx-auto mb-4"></div>
        <h1 className="text-2xl font-bold text-white">Loading ERP System...</h1>
      </div>
    </div>
  );
};

export default Index;
